import { API } from "./client";

export const getRoomData = (roomKey) => {
  const params = {
    room_key: roomKey,
  };
  return API.get(route("retrospective.room.get.room"), { params });
};

export const getRoomCards = (roomId) => {
  const params = {
    retrospective_room_id: roomId,
  };
  return API.get(route("retrospective.room.get.card"), { params });
};

export const postAddCard = ({ roomKey, topic, value }) => {
  const params = {
    room_key: roomKey,
    topic,
    value,
  };
  return API.post(route("retrospective.card.create"), params);
};

export const deleteCard = ({ roomKey, cardId }) => {
  const params = {
    room_key: roomKey,
    card_id: cardId,
  };
  return API.delete(route("retrospective.card.delete"), { params });
};

export const patchCard = ({ roomId, cardId, value }) => {
  const params = {
    retrospective_room_id: roomId,
    card_id: cardId,
    value,
  };
  return API.patch(route("retrospective.card.edit"), params);
};

export const putEditCard = ({ roomKey, cardId, text }) => {
  const params = {
    room_key: roomKey,
    card_id: cardId,
    value: text,
  };
  return API.put(route("retrospective.card.edit"), params);
};

export const postMergeCard = ({ roomKey, topic, value }) => {
  const params = {
    room_key: roomKey,
    topic,
    value,
  };
  return API.post(route("retrospective.card.merge"), params);
};

export const postMoveCard = ({ roomKey, topic, value }) => {
  const params = {
    room_key: roomKey,
    topic,
    value,
  };
  return API.post(route("retrospective.card.move"), params);
};
